import { prop } from 'ramda';
import { useCallback } from 'react';
import { dispatcher } from 'dispatcher';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'js/store/hooks';
import { useGetCMSResourceURL } from 'js/hooks/useGetCMSResourceURL';
import { workerService } from 'js/services/worker.service';

import * as actions from './store/actions';
import * as Types from './types';

let promise: Promise<Types.IFormConfig[]> | undefined;

export const useGetForms = () => {
    const dispatch = useDispatch();
    const getCMSResourceURL = useGetCMSResourceURL();
    const requestStamp = useAppSelector(prop('requestStamp'));

    return useCallback((disableCache?: boolean) => {
        if (promise && !disableCache) {
            return promise;
        }

        promise = new Promise((resolve, reject) => {
            const requestURL = getCMSResourceURL('/initialResources/forms', { t: requestStamp || Date.now() });

            workerService.request<string, Types.IFormConfig[]>('forms', requestURL)
                .then((forms) => {
                    dispatcher.dispatch('forms:data', { isFormsLoaded: true, forms });
                    dispatch(actions.updateFormsData(forms));

                    resolve(forms);
                })
                .catch((e) => {
                    reject(`[Dynamic Forms] unable to get forms data "${requestURL} ${e}"`);
                    promise = undefined;
                });
        });

        return promise;
    }, [dispatch, getCMSResourceURL, requestStamp]);
};
